/*************************************************/
/* FAQ                                           */
/*************************************************/

export function faq($body, bodyLoadingClass) {
    const buttonSelector = ".faq-item__mark-button";
    const compactSearchResultSelector = ".search-result-compact";
    const localStorageKey = "markedFaqs";
    var typeTimer;

    const getListOfMarkedFaqs = function () {
        var listOfMarkedFaqs = JSON.parse(localStorage.getItem(localStorageKey));

        if (listOfMarkedFaqs) {
            return listOfMarkedFaqs;
        } else {
            return [];
        }
    }

    const hasUserMarkedFaqItem = function(faqId) {
        return getListOfMarkedFaqs().indexOf(faqId) > -1;
    }

    const updateListOfFaqItemsMarkedByUser = function (faqId) {
        let markedFaqs = getListOfMarkedFaqs();
        markedFaqs.push(faqId);
        localStorage.setItem(localStorageKey, JSON.stringify(markedFaqs));
    }

    const disableMarkingsIfAlreadyMarked = function() {
        const faqId = $("#faqId");

        if (faqId.length > 0) {
            if (hasUserMarkedFaqItem(faqId.val())) {
                $(buttonSelector).prop("disabled", true);
            }
        }
    }

    const getAndDisplaySearchResults = function (query) {
        var endpointUrl = $('.faq-search-form').attr("action");
        $.get(endpointUrl + "?altTemplate=FaqSearchResultsCompact&query=" + query).done(function(data) {
            $('.faq-search-form').append(data);
            $(compactSearchResultSelector).show();
        });
    }

    const init = function () {
        window.onunload = function () { }; //makes sure the JS is run when coming from another page using the back button

        let compactSearchResult = $(compactSearchResultSelector);
        $(window).on('popstate', function () {
            compactSearchResult.hide();
        });

        disableMarkingsIfAlreadyMarked();

        $(document).on('click',
            buttonSelector,
            function () {
                const element = $(this);
                const liked = element.hasClass("like");
                const faqId = $("#faqId").val();
                const nodeId = $("#nodeId").val();
                const currentMarks = parseInt(element.children("span").text());

                if (hasUserMarkedFaqItem(faqId)) return;

                $.post("/umbraco/api/faqapi/MarkFaqItem",
                    {
                        "liked": liked,
                        "faqId": faqId,
                        "nodeId": nodeId
                    }).done(function () {
                        element.children("span").text(currentMarks + 1);
                        $(buttonSelector).prop("disabled", true);
                        updateListOfFaqItemsMarkedByUser(faqId);
                });
            });

        $('#searchQuery').on('keyup',
            function () {
                $(compactSearchResultSelector).remove();

                const query = $(this).val();
                clearTimeout(typeTimer);
                typeTimer = setTimeout(function() { getAndDisplaySearchResults(query); }, 500);
            });

        $(document).on('click',
            function (e) {
                const clickTarget = $(e.target);
                let searchResultBox = $(compactSearchResultSelector);
                if (searchResultBox.length > 0 && clickTarget !== searchResultBox && clickTarget.closest(compactSearchResultSelector).length === 0 ) {
                    searchResultBox.remove();
                }
            });
    };

    init();
}